import styles from './FooterPageHead.module.scss';

interface IFooterPageHeadProps {
  headTitle: string;
  subTitile?: string;
}

const FooterPageHead = ({ headTitle, subTitile }: IFooterPageHeadProps) => (
  <div className={styles.wrapper}>
    <h1>{headTitle}</h1>
    <span>{subTitile}</span>
  </div>
);
export default FooterPageHead;
